import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import {Build} from "../../../models/build";

interface BuildCardProps {
    build: Build;
    onClick: (build: Build) => void;
}

export default function BuildCard({ build, onClick }: BuildCardProps) {
    return (
        <Card 
            variant="outlined" 
            sx={{ 
                bgcolor: 'background.paper',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                    boxShadow: 2,
                    transform: 'translateY(-2px)'
                }
            }}
            onClick={() => onClick(build)}
        >
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 0.5 }}>
                    <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                        {build.version_number}
                    </Typography>
                    <Chip
                        label={build.track}
                        size="small"
                        sx={{ height: 20, fontSize: '0.7rem' }}
                        color={build.track === 'stable' ? 'success' : build.track === 'beta' ? 'warning' : 'default'}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        <strong>Platform:</strong> {build.platform}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        <strong>Deployment:</strong> {build.deployment_type}
                    </Typography>
                    {build.released_at && (
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                            <strong>Released:</strong> {new Date(build.released_at).toLocaleDateString()}
                        </Typography>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
}
